import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fieldsetDefault: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  contentType: {
    id: 'Content Type',
    defaultMessage: 'Content Type',
  },
  news: {
    id: 'News',
    defaultMessage: 'News',
  },
  page: {
    id: 'Page',
    defaultMessage: 'Page',
  },
  event: {
    id: 'Event',
    defaultMessage: 'Event',
  },
  place: {  // Aggiungi questo nuovo messaggio
    id: 'Place',
    defaultMessage: 'Luogo',
  },
  attachments: { // Nuovo messaggio per "Allegati"
    id: 'Attachments',
    defaultMessage: 'Allegati',
  },

  sortOrder: {
    id: 'Sort Order',
    defaultMessage: 'Sort Order',
  },
  ascending: {
    id: 'Ascending',
    defaultMessage: 'Ascending',
  },
  descending: {
    id: 'Descending',
    defaultMessage: 'Descending',
  },
  cardStyle: {
    id: 'Card Style',
    defaultMessage: 'Card Style',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Immagine'
  },

  imageLeft: {
    id: 'Image Left',
    defaultMessage: 'Immagine a sinistra',
  },
  imageRight: {
    id: 'Image Right',
    defaultMessage: 'Immagine a destra',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Titolo del blocco',
  },
  bigTitle: {
    id: 'Titolo grande',
    defaultMessage: 'Titolo grande',
  },
  descrizione: {
    id: 'Descrizione',
    defaultMessage: 'Descrizione',
  },
  showDots: {
    id: 'Show Dots',
    defaultMessage: 'Mostra elementi decorativi',
  },
  yes: {
    id: 'Yes',
    defaultMessage: 'Sì',
  },
  no: {
    id: 'No',
    defaultMessage: 'No',
  },
  dotsPosition: {
    id: 'Dots Position',
    defaultMessage: 'Posizione degli elementi',
  },
  before: {
    id: 'Before',
    defaultMessage: 'Prima del titolo',
  },
  after: {
    id: 'After',
    defaultMessage: 'Dopo il titolo',
  },
  both: {
    id: 'Both',
    defaultMessage: 'Prima e dopo il titolo',
  },
  titleAlignment: {
    id: 'Title Alignment',
    defaultMessage: 'Allineamento del titolo',
  },
  contentAlignment: {
    id: 'Content Alignment',
    defaultMessage: 'Allineamento del contenuto',
  },
  styleElementInEvidence: {
    id: 'Style elemento in evidenza',
    defaultMessage: 'Stile del contenuto in evidenza',
  },
  chiaro: {
    id: 'chiaro',
    defaultMessage: 'Chiaro',
  },
  scuro: {
    id: 'scuro',
    defaultMessage: 'Scuro',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Sinistra',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Centro',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Destra',
  },
  top: {
    id: 'Top',
    defaultMessage: 'In Alto',
  },
  middle: {
    id: 'Middle',
    defaultMessage: 'Al Centro',
  },
  bottom: {
    id: 'Bottom',
    defaultMessage: 'In basso',
  },
  testoLink: {
    id: 'testoLink',
    defaultMessage: 'Testo link',
  },
  linkApprofondimento: {
    id: 'linkApprofondimento',
    defaultMessage: 'Link approfondimento',
  },
});

const blockSchema = (props) => {
  const { intl, data = {} } = props;
  const isVertical = data.cardStyle === 'vertical';
  const showDots = data.showDots === 'yes'; // Mappa "yes" a true

  return {
    title: 'Item in evidenza',
    required: ['contentType'],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.fieldsetDefault),
        fields: [
          'styleElementInEvidence',
          'title',
          'showDots',
          ...(showDots ? ['dotsPosition'] : []),
          'tipoElementi',
          'titleAlignment',
          'contentAlignment',
          'bigTitle',
          'descrizione',
          'testoLink',
          'linkApprofondimento',
          'image'
        ],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        type: 'string',
        widget: 'text',
      },
      showDots: {
        title: intl.formatMessage(messages.showDots),
        type: 'string',
        widget: 'select',
        choices: [
          ['yes', intl.formatMessage(messages.yes)],
          ['no', intl.formatMessage(messages.no)],
        ],
        default: 'no',
      },
      tipoElementi: {
        title: 'Tipo elementi decorativi',
        widget: 'select',
        choices: [
          ['baby', 'Bambino'],    
          ['circle', 'Cerchio'],
          ['spinner', 'Spinner'],         
        ],
        default: 'baby',
      },
      dotsPosition: {
        title: intl.formatMessage(messages.dotsPosition),
        widget: 'select',
        choices: [
          ['before', intl.formatMessage(messages.before)],
          ['after', intl.formatMessage(messages.after)],
          ['both', intl.formatMessage(messages.both)],
        ],
        default: 'both',
      },
      titleAlignment: {
        title: intl.formatMessage(messages.titleAlignment),
        widget: 'select',
        choices: [
          ['left', intl.formatMessage(messages.left)],
          ['center', intl.formatMessage(messages.center)],
          ['right', intl.formatMessage(messages.right)],
        ],
        default: 'left',
      },
      contentAlignment: {
        title: intl.formatMessage(messages.contentAlignment),
        widget: 'select',
        choices: [
          ['top', intl.formatMessage(messages.top)],
          ['middle', intl.formatMessage(messages.middle)],
          ['bottom', intl.formatMessage(messages.bottom)],
        ],
        default: 'top',
      },
      styleElementInEvidence: {
        title: intl.formatMessage(messages.styleElementInEvidence),
        widget: 'select',
        choices: [
          ['chiaro', intl.formatMessage(messages.chiaro)],
          ['scuro', intl.formatMessage(messages.scuro)],          
        ],
        default: 'chiaro',
      },
      bigTitle: {
        title: intl.formatMessage(messages.bigTitle),
        type: 'string',
        widget: 'text',
      },
      descrizione: {
        title: intl.formatMessage(messages.descrizione),
        type: 'string',
        widget: 'richtext',
      },
      testoLink: {
        title: intl.formatMessage(messages.testoLink),
        type: 'string',
        widget: 'text',
      },
      linkApprofondimento: {
        title: intl.formatMessage(messages.linkApprofondimento),
        description: 'se non metti il link non compare il testo',
        widget: 'url', // Cambiato a url per supportare link esterni e interni
        default: '/',
      },
     image: {
        title: intl.formatMessage(messages.image),
        widget: 'file',
        default: null,
      },
              
    },
  };
};

export default blockSchema;